import {Button, ButtonProps} from "@progress/kendo-react-buttons";
import {VivoPortal} from "../../utils/AppConstants";
import EnumIconButtonDefaultType = VivoPortal.EnumIconButtonDefaultType;
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as icons from "@fortawesome/free-solid-svg-icons";
import {library} from '@fortawesome/fontawesome-svg-core'
import './FlintIconButton.scss'
import {MouseEventHandler} from "react";

export default function FlintIconButton(props: flintIconButtonProps) {
    let icon = icons.faEye;
    switch (props.defaultIcon) {
        case EnumIconButtonDefaultType.Delete:
            icon = icons.faTrash;
            break;
        case EnumIconButtonDefaultType.Edit:
            icon = icons.faEdit;
            break;
        case EnumIconButtonDefaultType.Preview:
            icon = icons.faEye;
            break;
        case EnumIconButtonDefaultType.Download:
            icon = icons.faDownload;
            break;
        case EnumIconButtonDefaultType.InternalUrl:
            icon = icons.faLink;
            break;
        case EnumIconButtonDefaultType.ExternalUrl:
            icon = icons.faExternalLink;
            break;
        case EnumIconButtonDefaultType.Print:
            icon = icons.faPrint;
            break;
        case EnumIconButtonDefaultType.UnDelete:
            icon = icons.faTrashRestore;
            break;
        case EnumIconButtonDefaultType.Save:
            icon = icons.faSave;
            break;
        case EnumIconButtonDefaultType.Cancel:
            icon = icons.faCancel;
            break;
        case EnumIconButtonDefaultType.Select:
            icon = icons.faCheck;
            break;
        case EnumIconButtonDefaultType.Copy:
            icon = icons.faCopy;
            break;
        case EnumIconButtonDefaultType.Unlocked:
            icon = icons.faLockOpen;
            break;
        case EnumIconButtonDefaultType.Locked:
            icon = icons.faLock;
            break;
        case EnumIconButtonDefaultType.Plus:
            icon = icons.faPlus;
            break;
        default:
            icon = icons.faEye;
            break;
    }
    const {themeColor = "secondary", type = "button", className, defaultIcon, ...others} = props;
    const c = props.className ? `icon-btn ${props.className}` : "icon-btn";
    return (
        <Button className={c} themeColor={themeColor} type= {type} {...others}>
            <FontAwesomeIcon icon={icon} className={"m-0 p-0"}/>
        </Button>
    )
}

export interface flintIconButtonProps extends ButtonProps {
    defaultIcon?: EnumIconButtonDefaultType;
}